var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ab-config",attrs:{"data-is-onboarding-route-based":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }